import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';

import { SharedService } from 'src/app/core/services/shared.service';
import { PitchesService } from 'src/app/modules/pitches/pitches.service';
import { PotentialInvestor, UserProfile } from 'src/app/modules/pitches/pitches.interface';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { AutoCompleteSuggestions } from '../../../helpers/auto-complete';
import { SimpleActionCreator } from '../../../helpers/types';

declare const UIkit: any;
declare const autoComplete: any;

@Component({
  selector: 'app-edit-answer-modal',
  templateUrl: './edit-answer-modal.component.html',
  styleUrls: ['./edit-answer-modal.component.scss']
})
export class EditAnswerModalComponent implements OnInit {
  autoComplete: any;
  noAnswer: boolean;
  noUserChosen = false;
  responder = '';
  responderEdition = false;
  suggestedResponses: PotentialInvestor[];
  @Input() action: SimpleActionCreator<any>;
  @Input() answer = '';
  @Input() id: string;
  @Input() title: string;
  @Input() userId: string;
  @ViewChild('modal', { static: true }) modal: ElementRef;
  @ViewChild('answerText', { static: false }) answerText: ElementRef;

  constructor(private pitchesService: PitchesService, private sharedService: SharedService, private store: Store<any>) {}

  ngOnInit() {
    UIkit.modal('#editAnswerModal').show();

    UIkit.util.on('#editAnswerModal', 'hidden', this.sharedService.deleteModal.bind(this, this.modal));

    if (this.userId) {
      this.pitchesService.getProfile(this.userId).subscribe((user: UserProfile) => {
        this.responder = user.profile?.pnr
          ? user.first_name + ' ' + user.last_name + ', PNR: ' + user.profile?.pnr
          : user.first_name + ' ' + user.last_name;
      });
    } else {
      this.editResponder();
    }
  }

  answerHandler(event: Event): void {
    if ((event.target as HTMLInputElement).value) {
      this.noAnswer = false;
    }
  }

  addAutoComplete(): void {
    this.autoComplete = new autoComplete({
      delay: 900,
      minChars: 3,
      onSelect: this.selectUser.bind(this),
      renderItem: this.renderItem.bind(this),
      selector: 'input[name="responder"]',
      source: this.suggestUser.bind(this)
    });
  }

  editResponder(): void {
    this.responderEdition = true;
    this.addAutoComplete();
  }

  renderItem(item: string, search: string) {
    const index = item.search(' ');
    const userId = item.slice(0, index);
    const rest = item.slice(index + 1);
    search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
    return `<div class="autocomplete-suggestion" data-val="${rest}" id="${userId}">${rest.replace(re, '<b>$1</b>')}</div>`;
  }

  selectUser(e: MouseEvent, term: string, item: HTMLElement): void {
    this.responder = term;
    this.autoComplete.destroy();
    this.responderEdition = false;
    this.userId = item.id;
  }

  suggestUser(term: string, suggest: AutoCompleteSuggestions): void {
    this.pitchesService.searchUsers({ name: term }).subscribe((response: BackendResponse<PotentialInvestor>) => {
      this.suggestedResponses = response.results;
      suggest(
        response.results.map((user: PotentialInvestor) => {
          return user.pnr
            ? `${user.id} ${user.first_name} ${user.last_name}, PNR: ${user.pnr}`
            : `${user.id} ${user.first_name} ${user.last_name}`;
        })
      );
    });
  }

  updateAnswer(): void {
    if (this.answerText.nativeElement.value && !this.responderEdition && this.userId) {
      return this.store.dispatch(this.action({ id: this.id, answer: this.answerText.nativeElement.value, userId: this.userId }));
    }
    if (!this.answerText.nativeElement.value) {
      this.noAnswer = true;
    }
    if (this.responderEdition || !this.userId) {
      this.noUserChosen = true;
    }
  }
}
